import { formatBytes, usageMeterOf, type UsageMeter } from "@buildpy/core/modules/plan/usage-limit";

// 사진 올리기 아래 한 줄 — 용량 80% 이상일 때만(addedBytes 는 아직 셸에 안 잡힌 양) · 한도가 없거나 넉넉하면 null · 막지 않는다.
export const uploadUsageLineOf = (meter: UsageMeter | null | undefined, addedBytes = 0): { level: "near" | "over"; text: string } | null => {
  if (!meter || meter.limit === null) return null;
  const now = usageMeterOf(meter.used + addedBytes, meter.limit);
  if (now.level === "ok") return null;
  const amount = `${formatBytes(now.used)} / ${formatBytes(meter.limit)}`;
  return now.level === "near"
    ? { level: "near", text: `올리면 ${amount} 에서 더 늘어납니다. 한도를 넘어도 올라갑니다.` }
    : { level: "over", text: `저장 공간 ${amount} — 한도를 넘었지만 올리기는 계속 됩니다.` };
};
